import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ComponentLoader, Row, Col } from '@snsw/react-component-library';
import { clearApplication, getApplication } from 'shared/redux/applicationSlice';
import { store } from 'shared/redux/configureStore';
import { clearForm, clearPlantDesignForm } from 'plantItemNew/redux/slices/formSlice';
import { PlantItemConstants } from 'plantItemNew/constants/plantItemConstants';
import { PlantDesignConstants } from 'plantDesign/constants/plantDesignConstants';
import { UnauthorizedApplicationError } from './UnauthorizedApplicationError';
import { InvalidApplicationError } from './InvalidApplicationError';
import { PagePath } from 'shared/constants/pagePath';
import _ from 'lodash';

export const ResumeApplication = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [isUnauthorized, setIsUnauthorized] = useState(false);
  const [isApplicationInvalid, setIsApplicationInvalid] = useState(false);

  useEffect(() => {
    if (props.licenceType === PlantItemConstants.licenceType) {
      store.dispatch(clearForm());
    } else if (props.licenceType === PlantDesignConstants.licenceType) {
      store.dispatch(clearPlantDesignForm());
    }
    store.dispatch(clearApplication());
  }, []);

  const fetchApplication = async (appId) => {
    if (!appId && isNaN(appId)) return;

    let response = await store.dispatch(getApplication(appId)).unwrap();

    if (response && response.unauthorized) {
      setIsUnauthorized(true);
    } else if (response && response.hasExpired) {
      setIsApplicationInvalid(true);
    }

    if (!_.isEmpty(response?.applicationData)) {
      redirect(response.applicationData);
    }
  };

  const redirect = (appData) => {
    const lastVisitedPath = appData?.application?.currentPath || appData?.form?.redirectTo;
    if (lastVisitedPath) {
      navigate(lastVisitedPath);
      return;
    }

    console.warn('Cannot find the last visited path.');
    const rootPath =
      props.licenceType === PlantItemConstants.licenceType
        ? PagePath.plantItemNewRoot
        : PagePath.plantDesignApplicantDetails;

    navigate(rootPath);
  };

  useEffect(() => {
    fetchApplication(id);
  }, [id]);

  return (
    <>
      {!isUnauthorized && !isApplicationInvalid && (
        <Row>
          <Col span={12}>
            <ComponentLoader fullPage />
          </Col>
        </Row>
      )}

      {isUnauthorized && <UnauthorizedApplicationError licenceType={props.licenceType} />}

      {isApplicationInvalid && <InvalidApplicationError licenceType={props.licenceType} />}
    </>
  );
};
